import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import CommError from '../../Shared/Errors/Errors'

import './ViewQuote.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const ViewQuote = (
    {
        errQuote,
        errQuoteClear,

        curQuote,
  
        isOpen,

        onRequestCancel
    }) => (
    <Modal isOpen={isOpen} onRequestCancel={onRequestCancel} style={styling}>
        <CommError error={errQuote.error} onClose={errQuoteClear} />

        <div className="viewquote editpages productManagement">
            <h1>Quote Request</h1>

            <div className="row">
                <div className="col-md-12">
                    <div className="quote-blk">
                        <p className="quote-blk-hdg">Details for this Quote Request</p>

                        <div className="row child-row">
                            <div className="col-md-4">
                                <p>Customer Number:</p>
                                <p>{curQuote.customerNumber}</p>
                            </div>
                            <div className="col-md-4">
                                <p>Customer Name:</p>
                                <p>{curQuote.customerName}</p>
                            </div>
                            <div className="col-md-4">
                                <p>Ordered By:</p>
                                <p>{curQuote.orderedBy}</p>
                            </div>
                        </div>

                        <div className="row child-row">
                            <div className="col-md-4">
                                <p>Order Key:</p>
                                <p>{curQuote.orderKey}</p>
                            </div>
                            <div className="col-md-4">
                                <p>Status:</p>
                                <select disabled>
                                    <option>New</option>
                                </select>
                                </div>
                            <div className="col-md-4">
                                <p>PO Number:</p>
                                <p>{curQuote.poNumber}</p>
                            </div>
                        </div>

                        <div className="row child-row">
                            <div className="col-md-4">
                                <p>Quote Request Number:</p>
                                <p>{curQuote.id}</p>
                            </div>
                        </div>
                    </div>

                    <div className="quote-blk">
                        <p className="quote-blk-hdg">Details for this Quote Request</p>

                        <div className="row child-row">
                            <table className="lists table table-striped">
                                <thead>
                                    <tr className="head">
                                        <th>Reico SKU</th>
                                        <th>Product Name</th>
                                        <th>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        curQuote.quoteRequestItems.map((item, index) => {
                                            return <tr className="body" key={index}>
                                                <td>{item.reicoSKU}</td>
                                                <td>{item.productName}</td>
                                                <td>{item.quantity}</td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="form-group buttons pull-right">
                    <a className="btn user-cancel btn-default" onClick={onRequestCancel}>Cancel</a>
                </div>
            </div>
        </div>
    </Modal>
);

// Modal.setAppElement('body');
        
export default ViewQuote